import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
} from '@angular/router';

import {AuthService} from "./auth.service";
import { AppService } from '../../app/services/app.service';


@Injectable({
  providedIn: 'root',

})
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService, appService: AppService, private router: Router) {
  }
  canActivate() {

    if(this.auth.IsLoggedIn()){
      return true;
    }
    this.router.navigate(['/login']);
    return false
  }

}



@Injectable({
  providedIn: 'root'
})
export class AuthAdminGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {
  }
  canActivate(): Promise<boolean> {
    return this.auth.IsAdminLogin();
  }

}
